import React from 'react';

interface Props {
  className?: string;
  onClick?: React.MouseEventHandler<SVGElement>;
  iconName: string;
}

export const IconTool = (props: Props) => (
  <svg
    className={`icon${props.className != null ? ` ${props.className}` : ''}`}
    viewBox="0 0 100 100"
    onClick={props.onClick}
    dangerouslySetInnerHTML={{ __html: `<use xlink:href="${props.iconName}"></use>` }}
  />
);
